<template>
  <div
    class="table-header"
    :class="{
      'table-header--sortable': !!header.sortable,
      'table-header--sorted': header.key === sortBy,
    }"
    @click="setSortBy"
  >
    {{ header.text }}
  </div>
</template>

<script>
export default {
  name: "history-table-header",
  props: {
    header: {
      type: Object,
      required: true,
    },
    sortBy: {
      type: String,
      default: "",
    },
    sortDir: {
      type: String,
      default: "",
    },
  },
  methods: {
    setSortBy() {
      const { key, sortable } = this.header;

      if (!sortable) {
        return;
      }

      let { sortBy, sortDir } = this;

      if (sortBy !== key) {
        sortBy = key;
        sortDir = null;
      }

      if (!sortDir) {
        sortDir = "asc";
      } else if (sortDir === "asc") {
        sortDir = "desc";
      } else {
        sortBy = null;
        sortDir = null;
      }

      this.$emit("update:sortBy", sortBy);
      this.$emit("update:sortDir", sortDir);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/vars';

.table-header {
  display: flex;
  transition: color 250ms ease-in-out;

  &--sortable {
    user-select: none;
    cursor: pointer;
  }

  &--sorted {
    color: $color-primary;
  }
}
</style>